import {
  BaseNodeAdditionalDataType,
  BaseNodeComponentType,
  BaseNodeDataType,
  BaseNodePropsType,
  SpecializedNodeProps,
} from "../WorkflowUtils";
import BaseNode from "./BaseNode";

type StartNodeAdditionalDataType = BaseNodeAdditionalDataType & {};

type StartNodeDataType = BaseNodeDataType<StartNodeAdditionalDataType>;

type Props = {} & BaseNodePropsType<StartNodeDataType>;

/**
 * Start node.
 *
 * Used to define the workflow's entry point.
 * Is unique, there can be only one StartNode, and it's required and must always be present.
 *
 * Displays a start icon.
 * Has only one east port.
 */
const StartNode: BaseNodeComponentType<Props> = (props) => {
  return (
    <BaseNode {...props}>
      {(nodeProps: SpecializedNodeProps<StartNodeDataType>) => {
        return (
          <div className={`node-content start-content`}>
            Start
            <p>[ {nodeProps.node.id} ]</p>
          </div>
        );
      }}
    </BaseNode>
  );
};

export default StartNode;
